<ng-template #menuItem let-isActive="isActive">
    <div
        class="list-item"
        [ngClass]="{ 'meeting-mode': menuState === 'in' }"
        fxLayout="column"
        [matTooltip]="menuState === 'in' && title ? (title | transloco) : ''"
        matTooltipPosition="right"
    >
        <button
            mat-list-item
            title
            class="btn-reset-style"
            [routerLink]="path"
            (click)="onMenuItemClick()"
        >
            <vsc-icon
                [icon]="icon"
                [iconStyle]="isActive ? 'solid' : 'regular'"
            ></vsc-icon>
            <div
                fxFlex
                fxLayout="row"
                fxLayoutAlign="space-between center"
                class="content"
            >
                <span class="title" *ngIf="!menuState || menuState !== 'in'">{{
                    title | transloco
                }}</span>
                <span
                    class="note"
                    *ngIf="note && (!menuState || menuState !== 'in')"
                >
                    {{ note }}
                </span>
            </div>
        </button>
        <div class="border"></div>
    </div>
</ng-template>
<ng-container
    *ngTemplateOutlet="menuItem; context: { isActive: isActive$ | async }"
></ng-container>
